(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["registration-discount-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('registration-discount-popup')) {
    customElements.define(
      'registration-discount-popup',
      class RegistrationDiscountPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.copyButton = this.querySelector('[data-copy-code]');
          this.copyStatus = this.querySelector('[data-copy-status]');

          if (!this.dialog || this.shouldStayClosed()) return;

          this.querySelectorAll('[data-popup-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.dialog.addEventListener('close', () => this.rememberDismissal());
          this.querySelector('[data-register-link]')?.addEventListener('click', () => this.rememberDismissal());
          this.copyButton?.addEventListener('click', () => this.copyCode());

          const delay = Number.parseInt(this.dataset.delay || '0', 10);
          window.setTimeout(() => this.open(), delay);
        }

        shouldStayClosed() {
          const previewOverride = new URLSearchParams(window.location.search).has('show_discount_popup');
          if (window.Shopify?.designMode || previewOverride) return false;
          if (this.dataset.customerAuthenticated === 'true') return true;

          try {
            const dismissedAt = Number.parseInt(localStorage.getItem(this.dataset.storageKey) || '0', 10);
            const dismissDays = Number.parseInt(this.dataset.dismissDays || '7', 10);
            return dismissedAt > Date.now() - dismissDays * 86400000;
          } catch (error) {
            return false;
          }
        }

        open() {
          this.hidden = false;
          if (!this.dialog.open) this.dialog.showModal();
        }

        rememberDismissal() {
          if (window.Shopify?.designMode) return;

          try {
            localStorage.setItem(this.dataset.storageKey, String(Date.now()));
          } catch (error) {}
        }

        async copyCode() {
          const code = this.copyButton?.dataset.copyCode;
          if (!code) return;

          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.append(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }

          const label = this.copyButton.querySelector('[data-copy-label]');
          const copiedLabel = this.copyStatus?.dataset.copiedLabel || '';
          if (label) label.textContent = copiedLabel;
          if (this.copyStatus) this.copyStatus.textContent = copiedLabel;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
